export const isTablet = '@media (max-width: 1320px)';
export const isMobile = '@media (max-width: 830px)';
